<template>
  <v-form ref="listJointTypeForm">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pb-0">
          <div class="d-flex" v-if="filterBadge.length > 0">
            <v-chip small class="mr-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" :class="[$vuetify.breakpoint.mdAndDown ? 'text-left' : 'text-right']">
          <v-btn v-if="$checkRight(['edit_joint_type'])" :to="'jointType/create'" class="primary" small>Add</v-btn>
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="deactiveJointType" class="ml-2" small color="#eee"  v-if="$checkRight(['edit_joint_type'])">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
              <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Datatable -->
      <datatable
        ref="jointType_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
      <!-- Filter -->
      <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
        <v-col cols="12">
          <v-text-field
            placeholder="Name"
            label="Name"
            v-model="filter.name"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Status"
            placeholder="Status"
            v-model="filter.status"
            :items="[{id: 0, text: 'Active', color: 'success'}, {id: 1, text: 'Inactive', color: 'warning'}]"
            :small-chips="true">
            <template #selection="{ item }">
              <v-chip :color="item.color" small>{{item.text}}</v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
          <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
        </v-col>
      </popup-drawer>
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  computed: {
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {
    if (!this.$checkRight(['edit_joint_type'])) {
      this.tableOption.headers.shift()
    }
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getJointTypeAll',
        editUrl: 'jointType/edit',
        deleteRoute: 'deactiveJointType',
        moduleName: 'jointType',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
      openDrawer: false,
      filter: {},
      filterDisplay: {}
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveJointType () {
      this.$refs.jointType_datatable.massDeleteTableData()
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
    }
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
